import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import PageServicePrincipalsProjectDetailKeys from 'hcp/components/page/service-principals/project/detail/keys';
import PageServicePrincipalsOrganizationDetailKeys from 'hcp/components/page/service-principals/organization/detail/keys';

<template>
  <BreadcrumbsItem
    @icon={{unless @controller.model.isProjectContext "robot"}}
    @route="cloud.access-control.service-principals.detail.keys"
    @text={{t
      "components.page.access-control.service-principals.details.keys.title"
      spName=@controller.model.servicePrincipal.name
      htmlSafe=true
    }}
    data-test-service-principal-detail-keys-breadcrumb
  />

  {{#if @controller.model.isProjectContext}}
    <PageServicePrincipalsProjectDetailKeys @model={{@controller.model}} />
  {{else}}
    <PageServicePrincipalsOrganizationDetailKeys @model={{@controller.model}} />
  {{/if}}
</template>
